import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Stack, Typography } from 'styles';
import {
	SERVICES_GROUPS,
	SERVICES_SHORT_TRANSLATION_KEY,
	TRANSLATION_KEYS,
} from 'utils/constants';
import { useTranslation } from 'utils/translations';

const LegendForServiceType = () => {
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const { servicesMap } = useSelector((state: RootState) => state.claim);

	const services = servicesMap.map(service => {
		const initial = tDbLabels(
			`${service.label}.${SERVICES_SHORT_TRANSLATION_KEY}`,
		);

		if (service.group.code === SERVICES_GROUPS.OTHERS) {
			const other = tClientLabels(service.group.label);

			const serviceLabel = tDbLabels(service.label);

			const itemLabel = tClientLabels('service.legend.otherItem', {
				initial,
				other,
				service: serviceLabel,
			});

			return itemLabel;
		}

		return tClientLabels('service.legend.item', {
			initial,
			service: tDbLabels(service.label),
		});
	});

	return (
		<Stack direction={'row'} alignItems={'baseline'}>
			<Typography variant="bodyLink" sx={{ whiteSpace: 'nowrap' }}>
				{tClientLabels('claim.legend.title')}
			</Typography>
			<Stack
				direction={'row'}
				sx={{ marginLeft: 2 }}
				flexWrap={'wrap'}
				gap={2}
				rowGap={1}
			>
				{services.map((service, index) => (
					<Typography key={index} variant="body">
						{service}
					</Typography>
				))}
			</Stack>
		</Stack>
	);
};

export default LegendForServiceType;
